// This is the "common" entry-point for webpack
// It should include all common, shared and vendor resources to be webpack-ed, that are not specific to this app.

// Ensure support for "async" and friends (required now by ValidatorJS, and KendoUI)
// import '@babel/polyfill'

// Include required Font Awesome 5 resources for iconography
// Pro Fonts
import "@fortawesome/fontawesome-pro/css/light.css"
import "@fortawesome/fontawesome-pro/css/regular.css"
import "@fortawesome/fontawesome-pro/css/solid.css"
import "@fortawesome/fontawesome-pro/css/brands.css"
import "@fortawesome/fontawesome-pro/css/fontawesome.css"

// Application custom style
import "./sass/application.scss"

module.exports = {
   // Hook to allow triggering actions on page load
   onDocumentReady: (callback) => { $(document).ready(callback) }
}
